export default "__VITE_ASSET__Cq4ptnGU__"